<template>
  <div class="light-header">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col">
          <Logo
            :routeName="logoLinkRoute"
            :redirection="$props.disableLogoNavigation"
          />
        </div>
        <div v-if="toggleOption" class="col text-end">
          <LanguageDropdown />
        </div>
        <div v-else>
          <ChatBot v-if="false" />
          <ChatBotSmoochPM v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Logo from "@/apps/person-registration/shared-components/ui/Logo.vue";
import LanguageDropdown from "@/apps/person-registration/shared-components/ui/LanguageDropdown.vue";
import ChatBot from "@/apps/person-registration/components/chat-bot/ChatBot.vue";
import ChatBotSmoochPM from "@/apps/person-registration/components/chat-bot/ChatBotSmoochPM.vue";
import { useRoute } from "vue-router";
import { RouteName } from "@/apps/merchant3/router/RouteName";

defineProps({
  logoLinkRoute: String,
  disableLogoNavigation: {
    default: false,
    type: Boolean,
  },
});

const route = useRoute();
const toggleOption = ref(true);

if (
  route.matched.some(
    ({ name }) =>
      name === "PersonLogin" ||
      name === RouteName.M3RMerchantRequestResetPassword ||
      name === RouteName.M3RMerchantRecreatePassword ||
      name === RouteName.M3ClerkLogin ||
      name === RouteName.M3MerchantLogin ||
      name === "Home"
  )
) {
  toggleOption.value = true;
} else {
  toggleOption.value = false;
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.light-header {
  background: $pj-color-white;
  @media screen and (max-width: $mobile) {
    background: none;
  }

  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);
}

.chat-icon {
  cursor: pointer;

  img {
    width: 35px;
  }
}
</style>
